import { Link } from "react-router-dom";
import { blogArticles } from "@/mocks/blog";

export default function BlogSection() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            Sugargoo Spreadsheet Guides
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            Expert articles to help you shop smarter with curated spreadsheets
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {blogArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              className="group rounded-xl overflow-hidden border border-background-200/70 bg-background-50 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full font-medium">
                    {article.category}
                  </span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center text-sm font-medium text-primary-600">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line ml-1 group-hover:ml-2 transition-all"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}